import React from 'react'


/**
 * Удаляет поля null | undefiend
 * @param data 
 * @returns 
 */
function revalidateData(data: object, fieldsToValidate: string[]) {
    const result = Object.fromEntries(Object.entries(data).filter(([key, value])=>(fieldsToValidate.includes(key) && !!value) || !fieldsToValidate.includes(key)))
    console.log("revalidateData", data, result)
    return result
}

export default revalidateData;